/**
 * `<img>` y `<audio>` que, para las fotos y audios de nuestro Storage, pintan la
 * copia guardada en el teléfono (y la guardan la primera vez que se ven). Con
 * cualquier otra URL se comportan exactamente igual que los de siempre.
 * Ver `src/lib/offline/fotosOffline.ts`.
 */
import { forwardRef, type AudioHTMLAttributes, type ImgHTMLAttributes } from "react";
import { useFotoOffline } from "@/lib/offline/fotosOffline";

export const ImgOffline = forwardRef<HTMLImageElement, ImgHTMLAttributes<HTMLImageElement>>(function ImgOffline(
  { src, ...resto },
  ref,
) {
  const s = useFotoOffline(src);
  return <img ref={ref} src={s} {...resto} />;
});

export const AudioOffline = forwardRef<HTMLAudioElement, AudioHTMLAttributes<HTMLAudioElement>>(function AudioOffline(
  { src, ...resto },
  ref,
) {
  const s = useFotoOffline(src);
  return <audio ref={ref} src={s} {...resto} />;
});
